import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { workbookNameSortOption } from '~src/views/models/sort/ViewSortOptions';

import { OrderKeys } from '../../../spacesPlatform/models/OrderKeys';

export const performanceSortOptions: OptionsDictionary = {
  // the options should be listed in alphabetical order after Recommended
  [OrderKeys.avgQueryBatchTime]: SortOptions.avgQueryBatchTime,
  [OrderKeys.containerName]: SortOptions.containerName,
  [OrderKeys.rank]: SortOptions.accelerationRecommended,
  [OrderKeys.targetName]: SortOptions.targetName,
  [OrderKeys.lastMonthViewCount]: SortOptions.lastMonthViewCount,
  [OrderKeys.workbookName]: workbookNameSortOption,
};